import { Component, OnInit, Input } from '@angular/core';

import { ControlValidatorBase, ControlValidatorModel } from '../../types/validator.types';
import { ValueControlViewModel, AbstractControl, ControlViewModel, AbstractValueControlBase } from '../../types';
import { RequiredValidatorData } from '../../validators/data-type/required';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'df-control-validate-label,df-control-validate-lable',
  templateUrl: './control-validate-label.component.html',
  styleUrls: ['./control-validate-label.component.css']
})
export class ControlValidateLabelComponent implements OnInit {
  /**
   * æ§ä»¶
   */
  @Input()
  get control(): AbstractControl<ValueControlViewModel> {
    return this._control;
  }

  set control(control: AbstractControl<ValueControlViewModel>) {
    if (control) {
      this.model = control.model;
      this.viewOnly = control.viewOnly;
      this.enableEditAtView = control.enableEditAtView;
      this.enableEditNameList = control.enableEditNameList;
      this.validators = (control as AbstractValueControlBase<any>).validators;
      // å½è¿éèµå¼æäºçæ¶åï¼ä¼è¦çå¨ç»ä»¶å è½½å®ä¹åè®¾ç½®è¿çhiddençå¼
      // æä»¥è¿å¤æ­ï¼å¦æèµå¼è¿ï¼åç¨ä¹åçå¼
      if (control.hidden === undefined) {
        control.hidden = this.model.isHidden;
      }
    }
    this._control = control;
  }

  model: ValueControlViewModel;
  viewOnly: boolean;
  enableEditAtView: boolean;
  enableEditNameList: string[];
  validators: Array<ControlValidatorBase>;

  /**
   * è¡¨åå¼å¯ãæ¥çæå¯ç¼è¾ãä¸æ¬æ§ä»¶åè®¸å¨æ¥çæç¼è¾ï¼å«ååè¿æ»¤ï¼ã
   */
  private get allowEditInView(): boolean {
    const list = this.enableEditNameList;
    return (
      !!this.enableEditAtView &&
      !!this.model.enableEditAtView &&
      (!list || list.length === 0 || list.includes(this.model.name))
    );
  }

  /**
   * æ¥çæ¾ç¤ºææ¬
   */
  get showContentAtView(): boolean {
    // return !(this.enableEditAtView && this.model.enableEditAtView) && this.viewOnly && this.model.showContentAtView;
    if (!this.viewOnly || !this.model.showContentAtView) {
      return false;
    }

    return !this.allowEditInView;
  }

  get required(): boolean {
    if (!this.model.validators) {
      return false;
    }
    const requiredValidator = this.model.validators.required as ControlValidatorModel<RequiredValidatorData>;
    if (!requiredValidator) {
      return false;
    }

    const required = requiredValidator && requiredValidator.required;
    if (!required) {
      return false;
    }

    if (this.viewOnly && requiredValidator.data) {
      return requiredValidator.data.showAtView || this.allowEditInView;
    }
    return required;
  }

  private _control: AbstractControl<ValueControlViewModel>;

  constructor() { }

  ngOnInit() { }
}
